const commonCz = {
    "restaurant": "Restaurace",
    "restaurant_not_found": "Restaurace není k dispozici",
    "table_not_available": "U tohoto stolu nelze zadávat objednávky",
    "note": "Poznámka",
    "order": "Objednávka",
    "internal_error": "Požadavek neúspěšný. Server odpověděl s následující chybou:",
    "no_results": "Žádné výsledky",
    "cancel": "Zrušit",
    "save": "Uložit",
    "back": "Zadní",
    "search": "Vyhledávání",
    "search_for_file_names": "Hledat názvy souborů",
    "delete": "Vymazat",
    "search_by_restaurant": "Hledat podle restaurace",
    "available": "K dispozici",
    "unavailable": "Nedostupné",
    "name": "Jméno",
    "status": "Postavení",
    "description": "Popis",
    "price": "Cena",
    "add": "Přidat",
    "phone": "Telefon",
    "internal_server_error": "Interní chyba serveru",
    "remove_all": "Vymazat vše",
    "settings": "Nastavení",
    "restaurant_name": "Název restaurace",
    "reservation_link": "Odkaz na rezervaci",
    "reservation_link_tooltip": "Povoleny jsou pouze odkazy na rezervační systém Reservours.",
    "add_user": "Přidat uživatele",
    "add_user_title": "Udělit přístup do restaurace",
    "restaurant_users": "Uživatelé s přístupem do restaurace",
    "restaurant_description_hu": "Popis restaurace (maďarská)",
    "restaurant_description_en": "Popis restaurace (anglicky)",
    "changes_saved": "Změny byly úspěšně uloženy",
    "user_added_to_restaurant": "Uživateli byl udělen přístup do restaurace",
    "user_add_to_restaurant_tip": "Uživatel s poskytnutou e-mailovou adresou získá přístup do vybrané restaurace. Pokud uživatel ještě nemá účet, získá přístup automaticky po registraci.",
    "sign_up_here": "Účet si můžete vytvořit zde",
    "role_already_exists": "Uživatel s tímto e-mailem již má přístup do restaurace",
    "error": "Chyba",
    "header_image": "Obrázek záhlaví",
    "upload_image": "Nahrát obrázek",
    "image_not_set": "Obrázek není nastaven",
    "validation": {
        "required": "Toto pole je povinné",
        "optional": "Toto pole je volitelné"
    },
    "hungary": "Maďarsko",
    "date": "Datum",
    "close": "Blízko",
    "continue": "Pokračovat",
    "select_image": "Vyberte obrázek",
    "grant": "Grant",
    "restaurant_settings": "Prostředí restaurace",
    "create_restaurant": "Vytvořit restauraci",
    "restaurant_created": "Restaurace byla úspěšně vytvořena",
    "restaurant_created_text": "Vaše restaurace byla úspěšně vytvořena. Nyní můžete přidávat položky v menu a spravovat nastavení restaurace.",
    "continue_to_menu": "Pokračovat k úpravě nabídky",
    "languages": {
        "hu": "maďarský",
        "en": "angličtina",
        "de": "Němec",
        "fr": "francouzština",
        "sk": "Slovák",
        "cz": "čeština",
        "pl": "polština",
        "si": "slovinský",
        "hr": "chorvatský",
        "ro": "rumunština"
    },
    "no_file_selected": "Není vybrán žádný soubor",
    "max_file_size": "Maximální velikost souboru:",
    "language": "Jazyk",
    "google_analytics": "Google Analytics",
    "facebook_pixel": "Facebook Pixel",
    "analytic_integration_premium_feature": "Integrace analytických služeb je součástí tarifu PRO",
    "refresh": "Obnovit",
    "address": "Adresa",
    "city": "Město",
    "postal_code": "Poštovní směrovací číslo",
    "timezone": "Časové pásmo",
    "country": "Země",
    "currency": "Měna",
    "currency_tooltip": "Toto je vyžadováno pouze pro nastavení profilu, náš systém nebude provádět finanční transakce za vás.",
    "or": "nebo"
};

export default commonCz;
